
// Packages
import axios from "axios";

const getExamDates = (date, setExamDates=null) => {
    /* 
        params:
            date: string;
                - a new Date() object as a string; new Date().toDateString(), 
                ||
                - 'all' to get an array of all ExamDate objects without time slots
            setExamDates: hook function to update examDate const from CalendarTile component
    */

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const token = localStorage.getItem("access_token");

    //axios call to Django view
    axios
    .get(`${process.env.REACT_APP_API_BASE_URL}api/exam-dates-and-time-slots/${date}/`, 
        {
            headers : {
                Authorization: `Bearer ${token}`
            }
    })
    .then((response) => {
        if (response.status === 200) {
            if (response.data['status'] === "empty") {
                setExamDates(null)
            } else {
                if (setExamDates) {
                    let examObject = response.data['exam_dates'];
                    let reserverObject = response.data['reserved_by']
                    let timeSlots = response.data['time_slots']
                    date === 'all' ? setExamDates(response.data) : setExamDates([examObject, reserverObject, timeSlots])
                }
            }
        }
    })
    .catch((error) => {
        console.log(error)
    });
}

export default getExamDates